import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
@Component({
  selector: 'app-reportSop-evaluation',
  templateUrl: './reportSop.component.html',
  styleUrls: ['./reportSop.component.css']
})
export class ReportSopComponent implements OnInit {

  constructor( public config: AppConfig,private router: Router) { }

  ngOnInit() {
  }

  onChildData(event: any) {

    switch(event.key){
      case 'processCompliance': this.router.navigate(['evaluation/observeSOP/processCompliance']);    break;
      case 'comments': this.router.navigate(['evaluation/observeSOP/sopComments']);    break;
      case 'individualData': this.router.navigate(['evaluation/observeSOP/sopIndividualOverview']);    break;
      case 'frequencyDistribution': this.router.navigate(['evaluation/observeSOP/frequencyDistribution']);    break;
      case 'overallCompliance': this.router.navigate(['evaluation/observe/overallCompliance']);    break;
      case 'fiveMoments': this.router.navigate(['evaluation/observe/fivemoments']);    break;
      case 'asepticProcedures': this.router.navigate(['evaluation/observe/StatisticsBeforeAsepticProcedures']);    break;
      case 'observeComments': this.router.navigate(['evaluation/observe/comments']);    break;
      default: this.router.navigate(['evaluation/observeSOP/subStepCompliance']);    break;
    }
  }
}
